import { useEffect, useState } from "react";

const SelectableSortableTable = ({
  columns,
  data,
  selectedRows,
  onSelectionChange,
  getRowId,
  onSelectAllPages,
  tableBodyClass = "",
  isAllPagesSelected = false,
  isRowSelectable = () => true,
}) => {
  const [tableData, setTableData] = useState(data);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  console.log(data);
  // const getRowId = (row) => row._tempId;
  const selectableRows = tableData.filter((row) => isRowSelectable(row));

  useEffect(() => {
    const dataWithIds = data.map((row, index) => ({
      ...row,
      _tempId: index + 1,
    }));
    setTableData(dataWithIds);
  }, [data]);

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const column = columns.find((col) => col.key === key);
    const sortedData = [...tableData].sort((a, b) => {
      if (column?.compare) {
        return direction === "asc"
          ? column.compare(a, b)
          : column.compare(b, a);
      }

      const valueA = a[key];
      const valueB = b[key];

      if (valueA == null) return direction === "asc" ? -1 : 1;
      if (valueB == null) return direction === "asc" ? 1 : -1;

      if (typeof valueA === "string" && typeof valueB === "string") {
        return direction === "asc"
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      }

      if (typeof valueA === "number" && typeof valueB === "number") {
        return direction === "asc" ? valueA - valueB : valueB - valueA;
      }

      return direction === "asc"
        ? String(valueA).localeCompare(String(valueB))
        : String(valueB).localeCompare(String(valueA));
    });

    setSortConfig({ key, direction });
    setTableData(sortedData);
  };

  const handleSelectAll = (e) => {
    const selectableIds = tableData
      .filter((row) => isRowSelectable(row))
      .map((row) => getRowId(row));

    if (e.target.checked) {
      if (onSelectAllPages) {
        // Select all across all pages
        onSelectAllPages(true);
      } else {
        // Select all on current page only
        onSelectionChange([...new Set([...selectedRows, ...selectableIds])]);
      }
    } else {
      // ALWAYS deselect all (across all pages)
      if (onSelectAllPages) {
        onSelectAllPages(false);
      } else {
        onSelectionChange(
          selectedRows.filter((id) => !selectableIds.includes(id)),
        );
      }
    }
  };
  return (
    <div className="table-responsive rounded-lg">
      <table className="resume custom">
        <thead>
          <tr>
            <th
              className="text-center"
              style={{
                width: selectableRows.length > 0 ? "auto" : "0px",
                padding: selectableRows.length > 0 ? "" : "0px",
              }}
            >
              {selectableRows.length > 0 && (
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={
                    selectableRows.length > 0 &&
                    (onSelectAllPages
                      ? isAllPagesSelected
                      : selectableRows.every((row) =>
                          selectedRows.includes(getRowId(row)),
                        ))
                  }
                />
              )}
            </th>
            {columns
              .filter((col) => !col.hidden)
              .map((col) => (
                <th
                  key={col.key}
                  onClick={() => col.sortable !== false && handleSort(col.key)}
                  style={{
                    cursor: col.sortable !== false ? "pointer" : "default",
                    textAlign: "center",
                  }}
                >
                  {col.label}{" "}
                  {sortConfig.key === col.key && col.sortable !== false
                    ? sortConfig.direction === "asc"
                      ? "▲"
                      : "▼"
                    : ""}
                </th>
              ))}
          </tr>
        </thead>
        <tbody className={`selectable-table-body ${tableBodyClass}`}>
          {tableData.map((row) => {
            return (
              <tr
                key={getRowId(row)}
                onClick={() => {
                  if (!isRowSelectable(row)) return;

                  const rowId = getRowId(row);
                  const newSelection = selectedRows.includes(rowId)
                    ? selectedRows.filter((r) => r !== rowId)
                    : [...selectedRows, rowId];

                  onSelectionChange(newSelection);
                }}
              >
                <td
                  className="text-center"
                  style={{
                    width: selectableRows.length > 0 ? "auto" : "0px",
                    padding: selectableRows.length > 0 ? "" : "0px",
                  }}
                >
                  {isRowSelectable(row) && (
                    <input
                      type="checkbox"
                      checked={selectedRows.includes(getRowId(row))}
                      onClick={(e) => e.stopPropagation()}
                      onChange={() => {
                        const rowId = getRowId(row);
                        const newSelection = selectedRows.includes(rowId)
                          ? selectedRows.filter((r) => r !== rowId)
                          : [...selectedRows, rowId];

                        onSelectionChange(newSelection);
                      }}
                    />
                  )}
                </td>
                {columns.map((col) => (
                  <td
                    className="text-center selectable-sortable-cell"
                    key={col.key}
                  >
                    {col.render(row)}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SelectableSortableTable;
